var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h6',[_c('small',{staticClass:"fw-bold"},[_vm._t("label",[_vm._v(_vm._s(_vm.label))]),_vm._v(": ")],2),_c('small',{staticClass:"fw-semi-bold"},[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }